
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { HeaderProvider } from "./context/HeaderContext";
import { SearchProvider } from "./components/bodyBlocks/cardsBlock/buscarFiltrar/SearchContext";
import App from "./App";
import AutoLogout from "./components/AutoLogout";


try {
  ReactDOM.createRoot(document.getElementById("root")!).render(
  
      <React.StrictMode>
        <HeaderProvider>
          <SearchProvider>
            <AutoLogout timeoutMinutes={5}>
              <App /> {/* App ya devuelve <RouterProvider router={router} /> */}
            </AutoLogout>
          </SearchProvider>
        </HeaderProvider>
      </React.StrictMode>
    );
    

} catch (e) {
  console.error("🚨 Error renderizando React:", e);
}
